export default __webpack_public_path__ + "static/media/33.ec388550.png";